import React from 'react';
import Slider from 'react-slick';
import Tilt from 'react-tilt';
import img1 from '../assets/img1.png';
import chat from '../assets/chat.jpg';
import desk from '../assets/desk.jpg';

const SliderImage = ({image}) => {
	var bgImage =
    (typeof image === 'string' || image instanceof String) &&
    image.length === 36
      ? `https://outlier-spa.github.io/EstudioPinedaWeb/${image}.png`
      : image;
	return (
		<Tilt options={{scale: 1.02, max: 6, perspective: 2000 }}  className="about_image">
			<div className="bg-cover" style={{backgroundImage: `url(${bgImage})`}}></div>
		</Tilt>
	);
}

export default class About extends React.Component {
	static defaultProps = {
		title: 'Lo que hacemos',
		description: 'En el Estudio FPP somos especialistas en la representación de los intereses de los clientes en materias civiles, laborales, de familia, derecho del consumidor, derecho inmobiliario, asuntos constitucionales y redacción de escritos, entre otros.',
		images: [
			{ imageId: img1 },
			{ imageId: chat },
			{ imageId: desk },
		]
	};
	settings = {
		dots: true,
		arrows: false,
		infinite: true,
		speed: 500,
		slidesToShow: 1,
		slidesToScroll: 1,
		autoHeight: true
	};

	render(){
		var { title, description, images } = this.props;
		return (
			<section className="about image__section " >
				<div className="inner__section">
					<div className="flex center-childs">
						<div className="flex1">
							<div>
								<h2 className="section__title in_view_animate">{title}</h2>
								<p className="in_view_animate">
									{description}
								</p>
							</div>
						</div>
						<div className="separation"></div>
						<div className="flex1">
							<div className="wp_slider">
								<Slider {...this.settings}>
									{ images.map((image, k) => (
										<SliderImage key={k} image={image.imageId} />
									)) }
								</Slider>
							</div>
						</div>
					</div>
				</div>
			</section>
		);
	}
}
